export const ROUTES = {
  LOGIN: '/login',
  INVITATION: '/invitation/:token',
  DASHBOARD: '/',
  WORKOUTS: '/workouts',
  WORKOUT_DETAILS: '/workouts/:id',
  USER: '/user/:id',
  EXERCISES: '/exercises',
  PROGRESSIONS: '/progressions',
} as const;
